// stores/useActiveModel.jsx
import { create } from "zustand";

const useActiveModel = create((set) => ({
    activeModel: "earth",
    morphTransition: false,

    setActiveModel: (model) => set({ activeModel: model }),
    startMorphTransition: () => set({ morphTransition: true }),
    endMorphTransition: () => set({ morphTransition: false }),
}));

export default useActiveModel;
